<template>
  <div class="view-joinorganization">
    <template v-if="data.organizationLicense && organization">
      <template v-if="membership?.accepted">
        {{ $t("messages.alreadyJoined") }}
      </template>
      <template v-else>
        <div class="view-joinorganization__main">
          <h1>{{ $t("headings.organizationInvitation", organization) }}</h1>
          <i18n-t
            tag="p"
            keypath="texts.organizationInvitationSummary"
            scope="global"
          >
            <template #invitorName>
              {{ data.organizationLicense.invitedBy?.name }}
            </template>
            <template #organizationName>
              <strong>{{ organization?.name }}</strong>
            </template>
          </i18n-t>

          <p>
            {{ $t("texts.organizationMemberInvitationDetails", organization) }}
          </p>

          <div class="line_flex -center">
            <button class="button" type="button" @click="accept()">
              {{ $t("actions.joinOrganization") }}
            </button>

            <button
              class="button button_secondary"
              type="button"
              @click="decline()"
            >
              {{ $t("actions.rejectInvitation") }}
            </button>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, watch } from "vue";
import { useRouter } from "vue-router";
import { useOrganizations } from "@manager/organizations/organizations.store";
import { useUser } from "@/api/user.store";
import { showError } from "@core/ui/alert/alert";

import type { OrganizationMember } from "@/api/Organization";

const props = defineProps<{
  organizationSlug: string;
}>();

const router = useRouter();

const { user } = useUser();
const {
  currentOrganization,
  joinOrganization,
  getOrganization,
  getOrganizationMember,
  leaveOrganization
} = useOrganizations(props, { user });

const organization = currentOrganization;

const data = reactive({
  organizationLicense: null as null | OrganizationMember
});

const membership = computed(() => currentOrganization.value?.membership);

watch(() => membership.value?.accepted, (accepted) => {
  if (accepted) {
    router.push({
      name: "settings-organization",
      params: {
        organizationSlug: props.organizationSlug
      }
    });
  }
}, { immediate: true });

watch(organization, async (org) => {
  data.organizationLicense = null;

  if (org == null) return;
  if (user.value == null) return;

  const orgLicense = await getOrganizationMember(
    org,
    user.value.id
  );

  data.organizationLicense = orgLicense;
  console.log(orgLicense, organization.value);
}, { immediate: true });
    
async function accept() {
  if (!organization.value || !user.value) {
    showError("No organization or user found");
    return;
  }
  await joinOrganization(organization.value, user.value);
  await getOrganization(props.organizationSlug);
  router.push({
    name: "settings-organization",
    params: {
      organizationSlug: props.organizationSlug
    }
  });
}
async function decline() {
  if (!organization.value || !user.value) {
    showError("No organization or user found");
    return;
  }
  try {
    await leaveOrganization(organization.value);
    router.push({
      name: "models-explorer"
    });
  } catch (error) {
    console.log(error);
  }
}
</script>

<style lang="scss">
.view-joinorganization {
  display: block;
  overflow: auto;
  margin: auto;
  text-align: center;
  padding: 2rem 3rem;

  &__main {
    max-width: 38rem;
  }
}
</style>
